import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';

export const getInviteInfo = (id, config) => {
    return hMacAjax.get(baseURL + `/apaas-system-service/identity/v1/invitation/${id}`, {}, config);
};

//确认加入
export const submitInviteInfo = (id, data, config) => {
    return hMacAjax.put(
        baseURL + `/apaas-system-service/identity/v1/invitation/${id}?phone_number=${data.phone_number}&captcha=${data.captcha}`,
        {},
        config
    );
};

//租户信息
export const tenantInfo = (config) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/tenant/v1', {}, config);
};
